import type { Scene } from '../types';
import apiRequest from './apiRequest';

export default async function getScene(
  sceneID: string,
  apiKey: string,
  signal?: AbortSignal,
) {
  return apiRequest<Scene>(
    'external-mogen',
    `/scenes/${encodeURIComponent(sceneID)}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
    signal,
  );
}
